<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        เพิ่มรายการส่งเสริมการขายอินเทอร์เน็ตความเร็วสูงประจำที่
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการข้อมูลอินเทอร์เน็ตประจำที่
          </a>
        </li>
        <li class="active">เพิ่มรายการส่งเสริมการขายอินเทอร์เน็ตประจำที่</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="row">
                <div class="col-sm-12">
                  <div class="layout_step_internet" style="padding-bottom: 20px">
                    <el-steps
                      :active="active"
                      finish-status="success"
                      simple
                      style="margin-top: 19px"
                      >
                      <el-step title="ขั้นตอนที่ 1" class="btn-step" @click.native="steps(0)"></el-step>
                      <el-step title="ขั้นตอนที่ 2" class="btn-step" @click.native="steps(1)"></el-step>
                      <el-step title="ขั้นตอนที่ 3" class="btn-step" @click.native="steps(2)"></el-step>
                      <el-step title="ขั้นตอนที่ 4" class="btn-step" @click.native="steps(3)"></el-step>
                      <el-step title="ขั้นตอนที่ 5" class="btn-step" @click.native="steps(4)"></el-step>
                    </el-steps>
                  </div>
                </div>
                <div class="col-sm-12">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="100px"
                      :model="form"
                      ref="ruleForm"
                    >
                      <el-form size="small" v-if="active===0" class='col-sm-12'>
                        <el-form-item label="รหัสรายการส่งเสริมการขาย"  required>
                          <el-input maxlength="20" clearable v-model="form.promotion_code"></el-input>
                        </el-form-item>
                        <el-form-item label="ชื่อรายการเสริมการขาย (ภาษาไทย)"  required>
                          <el-input show-word-limit maxlength="200" clearable v-model="form.promotion_name_th"></el-input>
                        </el-form-item>
                        <el-form-item label="ชื่อรายการเสริมการขาย (ภาษาอังกฤษ)" >
                          <el-input show-word-limit maxlength="200" clearable v-model="form.promotion_name_en"></el-input>
                        </el-form-item>
                        <el-form-item label="ประเภทเทคโนโลยีของการให้บริการ" required>
                          <el-select v-model="form.promotion_technology" filterable>
                            <el-option value="FTTx">FTTx</el-option>
                            <el-option value="VDSL">VDSL</el-option>
                            <el-option value="ADSL">ADSL</el-option>
                            <el-option value="WiFi">WiFi</el-option>
                            <el-option value="VAS">VAS</el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="ชนิดของรายการส่งเสริมการขาย" required>
                          <el-select v-model="form.promotion_type" filterable>
                            <el-option value="main" label="รายการส่งเสริมการขายหลัก (Main)"></el-option>
                            <el-option value="on-top" label="รายการส่งเสริมการขายเสริม (On top)"></el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item label="ระยะเวลา"></el-form-item>
                        <div class="row">
                          <div class="col-sm-6">
                            <el-form-item label="เริ่มต้นของการเสนอขาย" required>
                              <el-date-picker v-model="form.start_sale_date" type="date" placeholder="เลือกวันที่">
                              </el-date-picker>
                            </el-form-item>
                          </div>
                          <div class="col-sm-6">
                            <el-form-item label="สิ้นสุดของการเสนอขาย">
                              <el-date-picker v-model="form.end_sale_date" type="date" placeholder="เลือกวันที่">
                              </el-date-picker>
                            </el-form-item>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <el-form-item label="เริ่มต้นของการให้บริการ" required>
                              <el-date-picker v-model="form.start_service_date" type="date" placeholder="เลือกวันที่">
                              </el-date-picker>
                            </el-form-item>
                          </div>
                          <div class="col-sm-6">
                            <el-form-item label="สิ้นสุดของการให้บริการ">
                              <el-date-picker v-model="form.end_service_date" type="date" placeholder="เลือกวันที่">
                              </el-date-picker>
                            </el-form-item>
                          </div>
                        </div>
                        <el-form-item label="สถานะการให้บริการ" required>
                          <el-select v-model="form.service_status" style="width:220px;">
                            <el-option label="(S) เฉพาะรายการส่งเสริมการขายใหม่ (ยังขายอยู่)" value="S"></el-option>
                            <el-option label="(U) ไม่ขายแล้วแต่ยังให้บริการอยู่" value="U"></el-option>
                            <el-option label="(X) ยกเลิกการให้บริการแล้ว" value="X"></el-option>
                            <el-option label="(CS) Corporate (ยังขายอยู่)" value="CS"></el-option>
                            <el-option label="(CU) Corporate (ไม่ขายแล้วแต่ยังให้บริการอยู่)" value="CU"></el-option>
                            <el-option label="(CX) Corporate (ยกเลิกการให้บริการแล้ว)" value="CX"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="ค่าบริการรายเดือน (บาท)" :required="form.promotion_type == 'main'">
                          <el-input-number v-model="form.promotion_price" :precision="2" :step="10" :min="null" :max="999999999" style="width: 240px"></el-input-number>
                        </el-form-item>
                        <router-link to="/Operator/Manage_internet" style="margin-top: 12px;margin-bottom: 12px;float: left;">
                          <button
                            type="button"
                            class="btn btn-secondary"
                            >ยกเลิก
                        </button>
                        </router-link>
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: right;"
                          @click="next"
                          >
                          ขั้นตอนถัดไป
                          <i class="el-icon-right"></i>
                        </button>
                      </el-form>

                      <el-form size="small" v-if="active===1" class='col-sm-12'>
                        <el-form-item label="สิทธิการใช้งานที่ผู้ใช้บริการได้รับจำแนกตามประเภทบริการ"></el-form-item>
                        <el-form-item label="บริการ Internet" prop="voice_service">
                        </el-form-item>
                        <div class="row">
                          <div class="col-sm-6">
                          <el-form-item label="ความเร็วดาวน์โหลด (Mbps)" prop="download_speed" :required="form.promotion_type == 'main'">
                            <el-input-number v-model="form.download_speed" :precision="3" :step="10" :min="null" :max="99999" style="width: 240px"></el-input-number>
                          </el-form-item>
                          </div>
                          <div class="col-sm-6">
                            <el-form-item label="ความเร็วอัปโหลด (Mbps)" prop="upload_speed" :required="form.promotion_type == 'main'">
                              <el-input-number v-model="form.upload_speed" :precision="3" :step="10" :min="null" :max="99999" style="width: 240px"></el-input-number>
                            </el-form-item>
                          </div>
                        </div>
                        <p>*หากเลือกชนิดของรายการส่งเสริมการขายเป็น "รายการส่งเสริมการขายหลัก(main)"</p>
                        <p>กรุณากรอกความเร็วดาวน์โหลด และความเร็วอัปโหลด</p>
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: left;"
                          @click="back"
                        >
                          <i class="el-icon-back"></i>ย้อนกลับ
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: right;"
                          @click="next"
                        >
                          ขั้นตอนถัดไป
                          <i class="el-icon-right"></i>
                        </button>
                      </el-form>

                      <el-form size="small" v-if="active===2" class='col-sm-12'>
                        <el-form-item
                          label="การให้บริการเสริม (ที่คิดค่าใช้บริการ)"
                        ></el-form-item>
                        <el-form-item label="บริการความบันเทิง Contents (ภาษาไทย)" prop="content_service">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.content_service_th"></el-input>
                        </el-form-item>
                        <el-form-item label="บริการความบันเทิง Contents (ภาษาอังกฤษ) " prop="content_service">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.content_service_en"></el-input>
                        </el-form-item>
                        <el-form-item label="บริการโทรศัพท์เคลื่อนที่ (ภาษาไทย)" prop="mobile_service">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.mobile_service_th"></el-input>
                        </el-form-item>
                        <el-form-item label="บริการโทรศัพท์เคลื่อนที่ (ภาษาอังกฤษ)" prop="mobile_service">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.mobile_service_en"></el-input>
                        </el-form-item>
                        <el-form-item label="บริการ WiFi/Hotspot (ภาษาไทย)" prop="wifi_service">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.wifi_service_th"></el-input>
                        </el-form-item>
                        <el-form-item label="บริการ WiFi/Hotspot (ภาษาอังกฤษ)" prop="wifi_service">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.wifi_service_en"></el-input>
                        </el-form-item>
                        <el-form-item label="บริการ Fixed Line (ภาษาไทย)" prop="fixed_line_service">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.fixed_line_service_th"></el-input>
                        </el-form-item>
                        <el-form-item label="บริการ Fixed Line (ภาษาอังกฤษ)" prop="fixed_line_service">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.fixed_line_service_en"></el-input>
                        </el-form-item>
                        <el-form-item label="บริการอุปกรณ์อื่นๆ (ภาษาไทย)">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.device_service_th"></el-input>
                        </el-form-item>
                        <el-form-item label="บริการอุปกรณ์อื่นๆ (ภาษาอังกฤษ)">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.device_service_en"></el-input>
                        </el-form-item>
                        <el-form-item label="การให้บริการอื่นๆ (ภาษาไทย)" prop="other_service">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.other_service_th"></el-input>
                        </el-form-item>
                        <el-form-item label="การให้บริการอื่นๆ (ภาษาอังกฤษ)" prop="other_service">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.other_service_en"></el-input>
                        </el-form-item>

                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: left;"
                          @click="back"
                        >
                          <i class="el-icon-back"></i>ย้อนกลับ
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: right;"
                          @click="next"
                        >
                          ขั้นตอนถัดไป
                          <i class="el-icon-right"></i>
                        </button>
                      </el-form>
                    </el-form>
                    <el-form size="small" v-if="active===3" class='col-sm-12'>
                      <el-form-item label="สิทธิพิเศษ (ที่ไม่มีค่าใช้บริการ)"></el-form-item>
                      <el-form-item label="บริการความบันเทิง Contents (ภาษาไทย)">
                        <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_content_th"></el-input>
                      </el-form-item>
                      <el-form-item label="บริการความบันเทิง Contents (ภาษาอังกฤษ)">
                        <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_content_en"></el-input>
                      </el-form-item>
                      <el-form-item label="บริการโทรศัพท์เคลื่อนที่ (ภาษาไทย)">
                        <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_mobile_th"></el-input>
                      </el-form-item>
                      <el-form-item label="บริการโทรศัพท์เคลื่อนที่ (ภาษาอังกฤษ)">
                        <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_mobile_en"></el-input>
                      </el-form-item>
                      <el-form-item label="บริการ WiFi (ภาษาไทย)">
                        <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_wifi_th"></el-input>
                      </el-form-item>
                      <el-form-item label="บริการ WiFi (ภาษาอังกฤษ)">
                        <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_wifi_en"></el-input>
                      </el-form-item>
                      <el-form-item label="พรีเมียม (ภาษาไทย)">
                        <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_premium_th"></el-input>
                      </el-form-item>
                      <el-form-item label="พรีเมียม (ภาษาอังกฤษ)">
                        <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_premium_en"></el-input>
                      </el-form-item>
                      <el-form-item label="บริการอุปกรณ์อื่นๆ (ภาษาไทย)">
                        <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_device_th"></el-input>
                      </el-form-item>
                      <el-form-item label="บริการอุปกรณ์อื่นๆ (ภาษาอังกฤษ)">
                        <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_device_en"></el-input>
                      </el-form-item>
                      <el-form-item label="การให้บริการอื่นๆ (ภาษาไทย)">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_other_th"></el-input>
                      </el-form-item>
                      <el-form-item label="การให้บริการอื่นๆ (ภาษาอังกฤษ)">
                          <el-input show-word-limit maxlength="500" clearable v-model="form.privilege_other_en"></el-input>
                      </el-form-item>
                      <button
                        type="button"
                        class="btn btn-primary"
                        style="margin-top: 12px;margin-bottom: 12px;float: left;"
                        @click="back"
                      >
                        <i class="el-icon-back"></i>ย้อนกลับ
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        style="margin-top: 12px;margin-bottom: 12px;float: right;"
                        @click="next"
                      >
                        ขั้นตอนถัดไป
                        <i class="el-icon-right"></i>
                      </button>
                      </el-form>
                      <el-form size="small" v-if="active===4" class='col-sm-12'>
                        <div class="row">
                          <div class="col-sm-6">
                            <el-form-item label="อัตราค่าบริการอินเทอร์เน็ตต่อหน่วย (บาท/Mbps)">
                              <el-input-number v-model="form.internet_per_Mbps" :min="null" :max="999" :precision="10" style="width: 400px"></el-input-number>
                            </el-form-item>
                          </div>
                        </div>
                        <el-form-item label="ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาไทย)">
                          <el-input type="textarea"
                                    maxlength="500"
                                    show-word-limit
                                    :autosize="{ minRows: 4, maxRows: 4}"
                                    v-model="form.promotion_condition_th"></el-input>
                        </el-form-item>
                        <el-form-item label="ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาอังกฤษ)">
                          <el-input type="textarea"
                                    maxlength="500"
                                    show-word-limit
                                    :autosize="{ minRows: 4, maxRows: 4}"
                                    v-model="form.promotion_condition_en"></el-input>
                        </el-form-item>
                        <el-form-item label="ลิงก์เว็บไซต์ หรือลิงก์รายการส่งเสริมการขายของผู้ให้บริการ">
                          <el-input clearable v-model="form.promotion_link_url"></el-input>
                        </el-form-item>
                        <el-form-item label="ลิงก์รูปโฆษณา หรือรูปรายการส่งเสริมการขาย">
                          <el-input clearable v-model="form.promotion_banner"></el-input>
                        </el-form-item>
                        <button
                          type="button"
                          class="btn btn-primary"
                          style="margin-top: 12px;margin-bottom: 12px;float: left;"
                          @click="back"
                        >
                          <i class="el-icon-back"></i>ย้อนกลับ
                        </button>
                        <button
                          type="button"
                          class="btn btn-success"
                          style="margin-top: 12px;margin-bottom: 12px;float: right;"
                          :disabled="loading"
                          @click="save"
                        >บันทึก</button>
                      </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<style>
  .btn-step :hover {
    cursor: pointer;
    color:#3c8dbc !important
  }
</style>
<script>
import { mapState,mapActions } from "vuex"
export default {
  data() {
    return {
      label_position: "top",
      active: 0,
      form: {
          provider_id: '',
          created_promotion_from: "cms",
          promotion_code:"",
          promotion_name_th:"",
          promotion_name_en:"",
          promotion_technology:"",
          promotion_type:"",
          start_sale_date:"",
          end_sale_date: null,
          start_service_date:"",
          end_service_date: null,
          service_status: "",
          promotion_price:"",
          download_speed: null,
          upload_speed: null,
          content_service_th:"",
          content_service_en:"",
          mobile_service_th:"",
          mobile_service_en:"",
          wifi_service_th:"",
          wifi_service_en:"",
          fixed_line_service_th:"",
          fixed_line_service_en:"",
          device_service_th: "",
          device_service_en: "",
          other_service_th:"",
          other_service_en:"",
          privilege_content_th:"",
          privilege_content_en:"",
          privilege_mobile_th:"",
          privilege_mobile_en:"",
          privilege_wifi_th:"",
          privilege_wifi_en:"",
          privilege_premium_th:"",
          privilege_premium_en:"",
          privilege_device_th:"",
          privilege_device_en:"",
          privilege_other_th:"",
          privilege_other_en:"",
          internet_per_Mbps: null,
          promotion_condition_th:"",
          promotion_condition_en:"",
          promotion_link_url:"",
          promotion_banner:"",
      },
      dueDatePickerOptions: {
          disabledDate: this.disabledDueDate
      }
    };
  },
  computed: {
    ...mapState({
      loading : store => store.Manage_internet.loading,
      monthly : store => store.Manage_internet.monthly
    })
  },
  created(){
    this.$store.dispatch('Manage_internet/get_provider_id')
    this.$store.commit('Manage_internet/SET_LOADING', false)
  },
  mounted(){
    if(!this.monthly) this.$router.push({name : 'Operator_Manage_internet'})
  },
  methods: {
    next() {
      if(this.validate(this.active)){
        this.active++;
      }
    },
    back() {
      this.active--
    },
    save() {
      this.form.provider_id = this.$cookies.get('user_nbtc').provider_id
      this.form.admin_id = this.$cookies.get('user_nbtc').admin_id
      this.form.monthly_regulate = this.monthly
      let form_data = [this.form]
      this.$store.dispatch('Manage_internet/add_promotion', form_data)
    },
    validate: function(page){
      let pass = false;
      switch (page) {
        case 0:
          if(this.form.promotion_code == '') {
            this.$confirm("กรุณากรอกรหัสรายการส่งเสริมการขาย", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if(this.form.promotion_name_th == '') {
            this.$confirm("กรุณากรอกชื่อรายการส่งเสริมการขาย (ภาษาไทย)", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if(this.form.promotion_technology == '') {
            this.$confirm("กรุณาเลือกประเภทเทคโนโลยีของการให้บริการ", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if(this.form.promotion_type == '') {
            this.$confirm("กรุณาเลือกชนิดของรายการส่งเสริมการขาย", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if((this.form.start_sale_date == '') || (this.form.start_sale_date == null)) {
            this.$confirm("กรุณาเลือกวันเริ่มต้นของการเสนอขาย", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if((this.form.end_sale_date != null) && (this.form.start_sale_date >= this.form.end_sale_date)) {
            this.$confirm("วันที่สิ้นสุดของการเสนอขาย ต้องมากกว่าวันเริ่มต้นของการเสนอขาย", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if((this.form.start_service_date == '') || (this.form.start_service_date == null)) {
            this.$confirm("กรุณาเลือกวันเริ่มต้นของการให้บริการ", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if((this.form.end_service_date != null) && (this.form.start_service_date >= this.form.end_service_date)) {
            this.$confirm("วันที่สิ้นสุดของการให้บริการต้องมากกว่า วันเริ่มต้นของการให้บริการ", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if(this.form.service_status == '') {
            this.$confirm("กรุณากรอกสถานะการให้บริการ", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if(this.form.promotion_type == 'main' && !this.form.promotion_price) {
            this.$confirm("กรุณาระบุค่าบริการรายเดือน (บาท)", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else {
            pass = true;
          }
          break;
        case 1:
          if((this.form.promotion_type == 'main') && !this.form.download_speed) {
            this.$confirm("กรุณากรอกความเร็วในการดาวน์โหลด", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else if((this.form.promotion_type == 'main') && !this.form.upload_speed) {
            this.$confirm("กรุณากรอกความเร็วในการอัปโหลด", "แจ้งเตือน", {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
              showCancelButton: false,
              type: "warning"
            })
            break;
          } else {
            pass = true;
          }
          break;
        case 2:
          pass = true;
          break;
        case 3:
          pass = true;
          break;
        case 4:
          pass = true;
          break;
        default:
          return false
      }
      return pass
    },
    steps(number){
      let temp = this.active
      let going_page = number
      if (temp < number){
        for(let page = temp; page < number; page++){
          if(!this.validate(page)) {
            going_page = page
            break;
          }
        }
        this.active = going_page
      } else {
        this.active = going_page
      }
    }
  }
};
</script>
